import { ButtonSkeleton, CardSkeleton } from '@/components/shared/skeleton'

export const HoursCalendarSkeleton = () => (
  <div className="flex w-[304px] flex-col px-16 pt-12 xxs:w-full">
    <div className="mb-12 flex justify-between">
      <ButtonSkeleton className="h-24 w-24" />
      <ButtonSkeleton className="h-24 w-[106px]" />
      <ButtonSkeleton className="h-24 w-24" />
    </div>
    <div className="mb-20 flex flex-wrap justify-center">
      {Array.from({ length: 24 }).map((_, index) => (
        <ButtonSkeleton key={index} className="mx-10 my-5 h-24 w-48" />
      ))}
    </div>
    <ButtonSkeleton className="mb-20 h-32 w-[212px]" />
    <CardSkeleton className="h-44 w-full" />
  </div>
)
